import React from 'react';
import { observer } from 'mobx-react-lite';
import { PagesForm } from './PagesForm/PagesForm';
import { PagesGetType } from 'src/AppState/PagesState/PagesState';
import { useAppStateContext } from 'src/AppState/AppState';
import { PageItem } from './PageItem/PageItem';
import { LanguagesSelect } from './LanguageSelect/LanguageSelect';
import { ColumnOneOfTwo, MainContent, TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const Pages = observer(() => {
    const { pagesState, languageState } = useAppStateContext();

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={pagesState.isLoading}>
                        <Loader isActive={pagesState.isLoading}/>
                        <LanguagesSelect
                            selectOptions={languageState.languages}
                            setAction={pagesState.setFilterLanguage}
                            value={pagesState.filterLanguage}
                        />
                        {pagesState.allPagesSorted !== null && pagesState.allPagesSorted.map((page: PagesGetType | null) => {
                            return (page !== null) ? <PageItem key={page?.id} page={page} /> : null;
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <PagesForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
